import React from 'react';
import { Col, ContentContainer, Row, Button, Heading, SectionHeader,
    IconNotificationError } from '@snsw-gel/react';
import styles from './ResidencyError.module.scss';

const ResidencyErrorPage = () => {

    return (

        <>
            <SectionHeader className={ styles['heading-section'] }
                label='Apply for a NSW Seniors Card or NSW Senior Savers Card '>
                <Heading level={ 1 } >
                    <IconNotificationError />
                     Check if you are eligible
                </Heading>
            </SectionHeader>

            <ContentContainer className={ styles['content-container'] }>
                <Row>
                    <Col span={ 9 }>
                        <p>You must provide documents that prove you are an Australian citizen or permanent resident
                             to get a NSW Seniors or Senior Savers Card.
                            Check the documents you can use to prove your citizenship or
                            residency status in the eligibility guidelines.</p>
                    </Col>
                </Row>

                <Button
                    className={ styles['eligibility-button'] }
                    variant='primary'
                    aria-label='Check eligibility guidelines'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card#proof-of-identity' }>
                       Check eligibility guidelines
                </Button>
                <Button
                    className={ styles['home-button'] }
                    variant='secondary'
                    aria-label='Go to Service New South Wales homepage'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/' }>Go to Service NSW homepage
                </Button>

            </ContentContainer>
        </>
    );

};
export default ResidencyErrorPage;
